// React
import { useContext, useState } from "react"

// Contexts
import { DataContext } from "../../contexts"

// DnD kit
import { DragEndEvent } from "@dnd-kit/core"
import { arrayMove } from "@dnd-kit/sortable"

// Types
import type { HeaderListType } from "../../types"

export function useHeaders(headers: HeaderListType[]): {
  handleDragEnd: (
    event: DragEndEvent,
    type: "old" | "new"
  ) => void
  items: HeaderListType[]
  itemsNew: HeaderListType[]
  swapOrder: (
    index: number,
    type: "old" | "new"
  ) => void
} {
  // Hooks
  const { list } = useContext(DataContext)
  const [items, setItems] = useState<HeaderListType[]>(list.filter(item => !headers.includes(item)))
  const [itemsNew, setItemsNew] = useState<HeaderListType[]>(headers)

  // Functions
  function swapOrder(
    index: number,
    type: "old" | "new"
  ): void {
    if (type === "new") {
      // Vars
      const item = itemsNew.find((_, key) => key === index)

      setItemsNew((prev) => {
        // Vars
        const items = [...prev]

        items.splice(index, 1)
        return items
      })

      setItems((prev) => {
        // Vars
        const items = [...prev]

        items.push(item!)
        return items
      })
    } else {
      // Vars
      const item = items.find((_, key) => key === index)

      setItems((prev) => {
        // Vars
        const items = [...prev]

        items.splice(index, 1)
        return items
      })

      setItemsNew((prev) => {
        // Vars
        const items = [...prev]

        items.push(item!)
        return items
      })
    }
  }

  function handleDragEnd(
    event: DragEndEvent,
    type: "old" | "new"
  ): void {
    const {active, over} = event

    if (over && active.id !== over.id) {
      if (type === "new") {
        setItemsNew((items) => {
          const oldIndex = items.findIndex(item => item.value === active.id)
          const newIndex = items.findIndex(item => item.value === over.id)
          return arrayMove(items, oldIndex, newIndex)
        })

        return
      }

      setItems((items) => {
        const oldIndex = items.findIndex(item => item.value === active.id)
        const newIndex = items.findIndex(item => item.value === over.id)
        return arrayMove(items, oldIndex, newIndex)
      })
    }
  }

  return { items, itemsNew, handleDragEnd, swapOrder}
}